import React, { useState } from "react";
import {
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  IconButton,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  Paper,
  Typography
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import AddIcon from "@material-ui/icons/Add";
import { getLocalizedString } from "@icarius-localization/strings";

const TabIntellectualRequirements = (props) => {
  const { editMode, currentNode, handleChangeField, intellectualRequirementTypes, color, theme } = props;

  const [type, setType] = useState("");
  const [description, setDescription] = useState("");

  const items = currentNode["intellectualRequirements"] || [];

  const handleAdd = () => {
    if (!type || !description) return;
    const newItem = {
      type: type,
      description: description,
    };
    handleChangeField("intellectualRequirements", [...items, newItem]);
    setType("");
    setDescription("");
  };

  const handleDelete = (index) => {
    const newItems = [...items];
    newItems.splice(index, 1);
    handleChangeField("intellectualRequirements", newItems);
  };

  return (
    <div style={{ padding: 16 }}>
      {
        editMode && (
          <Paper style={{ padding: 16, marginBottom: 16, minHeight: 200, display: 'flex', flexDirection: 'column', justifyContent: 'center', backgroundColor: theme?.theme === "dark" ? '#1e1f20' : "#f0f4f9" }}>
            <Typography className="whiteText" variant="subtitle1" style={{ marginBottom: 16 }}>
              {getLocalizedString("addIntellectualRequirement")}
            </Typography>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} sm={4}>
                <FormControl fullWidth>
                  <InputLabel className="whiteText" id="type-label">
                    {getLocalizedString("type")}
                  </InputLabel>
                  <Select
                    labelId="type-label"
                    value={type}
                    onChange={(e) => setType(e.target.value)}
                    className="whiteText"
                  >
                    {
                      intellectualRequirementTypes && intellectualRequirementTypes.length > 0 && (
                        intellectualRequirementTypes.map((item) => (
                          <MenuItem key={item.key} value={item.key}>
                            {item.value}
                          </MenuItem>
                        ))
                      )
                    }
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={7}>
                <TextField
                  fullWidth
                  label={getLocalizedString("whichOnes")}
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  InputProps={{ className: "whiteText" }}
                  InputLabelProps={{ className: "whiteText" }}
                />
              </Grid>
              <Grid item xs={12} sm={1}>
                <Button
                  variant="contained"
                  onClick={handleAdd}
                  disabled={!type || !description}
                  style={{ backgroundColor: color, marginTop: 12, minWidth: 'auto', padding: '6px 12px' }}
                >
                  <AddIcon />
                </Button>
              </Grid>
            </Grid>
          </Paper>
        )
      }
      <List>
        {
          items.map((item, index) => {
            let typeLabel = item.type;
            if (intellectualRequirementTypes && intellectualRequirementTypes.length > 0) {
              const t = intellectualRequirementTypes.find(x => x.key === item.type);
              if (t) typeLabel = t.value;
            }

            return (
              <ListItem key={index} className="listItemBorderBottom">
                <ListItemText
                  primary={<span className="whiteText">{typeLabel}</span>}
                  secondary={<span className="whiteText">{item.description}</span>}
                />
                {
                  editMode && (
                    <ListItemSecondaryAction>
                      <IconButton edge="end" onClick={() => handleDelete(index)} style={{ color: '#ff4d4f' }}>
                        <DeleteIcon />
                      </IconButton>
                    </ListItemSecondaryAction>
                  )
                }
              </ListItem>
            )
          })
        }
        {
          items.length === 0 && (
            <Typography className="whiteText" style={{ textAlign: 'center', marginTop: 20 , color: "var(--react-tel-arrow-color)" }}>
              {getLocalizedString("noIntellectualRequirementsAdded")}
            </Typography>
          )
        }
      </List>
    </div>
  );
};

export default TabIntellectualRequirements;
